import { render } from "./DgWohnungStep4.vue?vue&type=template&id=fb9cd894&scoped=true"
import script from "./DgWohnungStep4.vue?vue&type=script&lang=js"
export * from "./DgWohnungStep4.vue?vue&type=script&lang=js"

import "./DgWohnungStep4.vue?vue&type=style&index=0&id=fb9cd894&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9cd894"]])

export default __exports__